"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripePaymentApi = void 0;
var runtime_1 = require("../runtime");
/**
 * no description
 */
var StripePaymentApi = /** @class */ (function (_super) {
    __extends(StripePaymentApi, _super);
    function StripePaymentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StripePaymentApi.prototype.sleekPayBalanceGet = function (_a, opts) {
        var platformCountry = _a.platformCountry;
        var headers = {};
        var query = {};
        if (platformCountry != null) {
            query['platformCountry'] = platformCountry;
        }
        return this.request({
            url: '/SleekPay/Balance',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPayCompanyLogoUrlGet = function (_a, opts) {
        var platformCountry = _a.platformCountry;
        var headers = {};
        var query = {};
        if (platformCountry != null) {
            query['platformCountry'] = platformCountry;
        }
        return this.request({
            url: '/SleekPay/company-logo-url',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPayCompanyPaymentsGet = function (_a, opts) {
        var statuses = _a.statuses, platformCountry = _a.platformCountry, offset = _a.offset, limit = _a.limit, sortBy = _a.sortBy, order = _a.order, staffId = _a.staffId, startDate = _a.startDate, endDate = _a.endDate;
        var headers = {};
        var query = {};
        if (statuses != null) {
            query['statuses'] = statuses;
        }
        if (platformCountry != null) {
            query['platformCountry'] = platformCountry;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (sortBy != null) {
            query['sortBy'] = sortBy;
        }
        if (order != null) {
            query['order'] = order;
        }
        if (staffId != null) {
            query['staffId'] = staffId;
        }
        if (startDate != null) {
            query['startDate'] = startDate;
        }
        if (endDate != null) {
            query['endDate'] = endDate;
        }
        return this.request({
            url: '/SleekPay/company/payments',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPayCompanyStaffIdentityIdPaymentsGet = function (_a, opts) {
        var identityId = _a.identityId, statuses = _a.statuses, isSystem = _a.isSystem, platformCountry = _a.platformCountry, offset = _a.offset, limit = _a.limit, sortBy = _a.sortBy, order = _a.order, startDate = _a.startDate, endDate = _a.endDate;
        (0, runtime_1.throwIfNullOrUndefined)(identityId, 'identityId', 'sleekPayCompanyStaffIdentityIdPaymentsGet');
        var headers = {};
        var query = {};
        if (statuses != null) {
            query['statuses'] = statuses;
        }
        if (isSystem != null) {
            query['isSystem'] = isSystem;
        }
        if (platformCountry != null) {
            query['platformCountry'] = platformCountry;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (sortBy != null) {
            query['sortBy'] = sortBy;
        }
        if (order != null) {
            query['order'] = order;
        }
        if (startDate != null) {
            query['startDate'] = startDate;
        }
        if (endDate != null) {
            query['endDate'] = endDate;
        }
        return this.request({
            url: '/SleekPay/company/staff/{identityId}/payments'.replace('{identityId}', (0, runtime_1.encodeURI)(identityId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPayCompanyTeamsPaymentsGet = function (_a, opts) {
        var statuses = _a.statuses, platformCountry = _a.platformCountry, offset = _a.offset, limit = _a.limit, sortBy = _a.sortBy, order = _a.order, staffId = _a.staffId, status = _a.status, startDate = _a.startDate, endDate = _a.endDate;
        var headers = {};
        var query = {};
        if (statuses != null) {
            query['statuses'] = statuses;
        }
        if (platformCountry != null) {
            query['platformCountry'] = platformCountry;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (sortBy != null) {
            query['sortBy'] = sortBy;
        }
        if (order != null) {
            query['order'] = order;
        }
        if (staffId != null) {
            query['staffId'] = staffId;
        }
        if (status != null) {
            query['status'] = status;
        }
        if (startDate != null) {
            query['startDate'] = startDate;
        }
        if (endDate != null) {
            query['endDate'] = endDate;
        }
        return this.request({
            url: '/SleekPay/company/teams/payments',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPayConnectGet = function (_a, opts) {
        var platformCountry = _a.platformCountry;
        var headers = {};
        var query = {};
        if (platformCountry != null) {
            query['platformCountry'] = platformCountry;
        }
        return this.request({
            url: '/SleekPay/Connect',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPayConnectedPlatformCountriesGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/SleekPay/connected-platform-countries',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPayDashboardGet = function (_a, opts) {
        var platformCountry = _a.platformCountry;
        var headers = {};
        var query = {};
        if (platformCountry != null) {
            query['platformCountry'] = platformCountry;
        }
        return this.request({
            url: '/SleekPay/Dashboard',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPayGeneratePaymentPost = function (_a, opts) {
        var travisBackendStripeIntegrationDomainModelsGenerateStripPaymentRequest = _a.travisBackendStripeIntegrationDomainModelsGenerateStripPaymentRequest;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/SleekPay/Generate/Payment',
            method: 'POST',
            headers: headers,
            body: travisBackendStripeIntegrationDomainModelsGenerateStripPaymentRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPayMessageTemplateGet = function (_a, opts) {
        var messageType = _a.messageType;
        var headers = {};
        var query = {};
        if (messageType != null) {
            query['messageType'] = messageType;
        }
        return this.request({
            url: '/SleekPay/message/template',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPayMessageTemplatePost = function (_a, opts) {
        var travisBackendStripeIntegrationDomainModelsStripePaymentMessageTemplateRequest = _a.travisBackendStripeIntegrationDomainModelsStripePaymentMessageTemplateRequest;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/SleekPay/message/template',
            method: 'POST',
            headers: headers,
            body: travisBackendStripeIntegrationDomainModelsStripePaymentMessageTemplateRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPayRefundPost = function (_a, opts) {
        var travisBackendStripeIntegrationDomainModelsRefundPaymentRequest = _a.travisBackendStripeIntegrationDomainModelsRefundPaymentRequest;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/SleekPay/refund',
            method: 'POST',
            headers: headers,
            body: travisBackendStripeIntegrationDomainModelsRefundPaymentRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPayReportExportPost = function (_a, opts) {
        var receiverEmailAddress = _a.receiverEmailAddress, startDate = _a.startDate, endDate = _a.endDate, platformCountry = _a.platformCountry;
        var headers = {};
        var query = {};
        if (receiverEmailAddress != null) {
            query['receiverEmailAddress'] = receiverEmailAddress;
        }
        if (startDate != null) {
            query['startDate'] = startDate;
        }
        if (endDate != null) {
            query['endDate'] = endDate;
        }
        if (platformCountry != null) {
            query['platformCountry'] = platformCountry;
        }
        return this.request({
            url: '/SleekPay/report/export',
            method: 'POST',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPayResultResultIdGet = function (_a, opts) {
        var resultId = _a.resultId;
        (0, runtime_1.throwIfNullOrUndefined)(resultId, 'resultId', 'sleekPayResultResultIdGet');
        var headers = {};
        return this.request({
            url: '/SleekPay/Result/{resultId}'.replace('{resultId}', (0, runtime_1.encodeURI)(resultId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPayStatusGet = function (_a, opts) {
        var platformCountry = _a.platformCountry;
        var headers = {};
        var query = {};
        if (platformCountry != null) {
            query['platformCountry'] = platformCountry;
        }
        return this.request({
            url: '/SleekPay/Status',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPaySupportedCurrenciesGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/SleekPay/supported-currencies',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPayUserProfileUserProfileIdPaymentsGet = function (_a, opts) {
        var userProfileId = _a.userProfileId, status = _a.status, offset = _a.offset, limit = _a.limit;
        (0, runtime_1.throwIfNullOrUndefined)(userProfileId, 'userProfileId', 'sleekPayUserProfileUserProfileIdPaymentsGet');
        var headers = {};
        var query = {};
        if (status != null) {
            query['status'] = status;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        return this.request({
            url: '/SleekPay/userProfile/{userProfileId}/payments'.replace('{userProfileId}', (0, runtime_1.encodeURI)(userProfileId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPayVolumeGet = function (_a, opts) {
        var volumeFrom = _a.volumeFrom, volumeTo = _a.volumeTo, platformCountry = _a.platformCountry;
        var headers = {};
        var query = {};
        if (volumeFrom != null) {
            query['volumeFrom'] = volumeFrom;
        }
        if (volumeTo != null) {
            query['volumeTo'] = volumeTo;
        }
        if (platformCountry != null) {
            query['platformCountry'] = platformCountry;
        }
        return this.request({
            url: '/SleekPay/volume',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    StripePaymentApi.prototype.sleekPayWebhookPaymentResultPost = function (_a, opts) {
        var travisBackendStripeIntegrationDomainModelsStripePaymentRecord = _a.travisBackendStripeIntegrationDomainModelsStripePaymentRecord;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/SleekPay/webhook/payment/result',
            method: 'POST',
            headers: headers,
            body: travisBackendStripeIntegrationDomainModelsStripePaymentRecord,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    return StripePaymentApi;
}(runtime_1.BaseAPI));
exports.StripePaymentApi = StripePaymentApi;
